import React from "react";
import "../pages/Proyect.css";
import htmlp from "../Assets/html_p.png";
import cssp from "../Assets/css_p.png";
import jsp from "../Assets/js_p.png";
import transmuta from "../Assets/card-desk.png";
import BackButton from "../componets/BackButton";
import firee from "../Assets/firebase_p.png";


export const CardValidation = () => {
        const handleWebButtonClick = () => {
    window.location.href = "https://susanalab.github.io/Card-Validation/"; // Reemplaza con la URL que quieras
  };

  const handleGitHubButtonClick = () => {
    window.location.href = "https://github.com/SusanaLab/Card-Validation"; // Reemplaza con la URL de tu repositorio en GitHub
  };
  return (
    <div className="proyect-container">
      <BackButton/>
      <div className="proyect-header">
        <h1>Card Validation</h1>
     
      <div className="proyect-description">
        <p>
        This project consists of a simple web application to validate credit card numbers. The application checks whether the entered number is valid according to the Luhn algorithm.
        </p>
      </div>
      <div className="proyect-buttons">
         <button className="proyect-button" onClick={handleWebButtonClick}>Web</button>
      <button className="proyect-button" onClick={handleGitHubButtonClick}>GitHub</button>
      </div>
      <div className="proyect-tech">
        <p>Technologies</p>
        <img src={htmlp} alt="HTML" className="computer" />
        <img src={cssp} alt="CSS" className="computer" />
      
      </div> </div>
      <img
        src={transmuta}
        alt="Learning List"
        id="new"
      />
    </div>
  );
};

